import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';

// material-ui
import { Box, Typography } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import adminMenuItems from 'menu-items/adminMenuItems';
import { useGiraf } from 'giraf/index';
import { urlAllowed } from 'utils/moduleCatalog';

const BASE = process.env.REACT_APP_API_URL;

// Recursively filter menu items by the user's module access + ownerOnly flag.
// modules === null ⇒ owner/unrestricted (everything visible).
function filterItems(items, modules, isOwner) {
  const walk = (node) => {
    if (!node) return null;
    if (node.children) {
      const children = node.children.map(walk).filter(Boolean);
      if (!children.length) return null;
      return { ...node, children };
    }
    // leaf item
    if (node.ownerOnly && !isOwner) return null;
    if (!urlAllowed(node.url, modules)) return null;
    return node;
  };
  return items.map(walk).filter(Boolean);
}

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const { gHead } = useGiraf();
  const isSuper = gHead.IsSuperAdmin;
  const token = gHead.AuthToken;

  // Default to unrestricted (owner) so the candidate's full menu shows while loading.
  const [access, setAccess] = useState({ modules: null, isOwner: true });

  useEffect(() => {
    if (isSuper || !token) return;
    axios
      .get(`${BASE}/accounts/profile`, { headers: { Authorization: token } })
      .then((r) => setAccess({ modules: r.data?.modules ?? null, isOwner: !!r.data?.isOwner }))
      .catch(() => setAccess({ modules: null, isOwner: true }));
  }, [isSuper, token]);

  const groups = useMemo(() => {
    if (isSuper) return adminMenuItems.items || [];
    return filterItems(menuItem.items || [], access.modules, access.isOwner);
  }, [isSuper, access]);

  const navGroups = groups.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return (
    <Box sx={{ pt: 2, minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
      {navGroups}
    </Box>
  );
};

export default Navigation;
